import React from "react";
import QuestionUser from "../Jeunes/QuestionsUsers";

function QuestionUserParent() {

  return <QuestionUser parent={true} />
}

export default QuestionUserParent;